// src/utils/auth.js

export const isLoggedIn = () => {
  try {
    return !!sessionStorage.getItem("user");
  } catch (e) {
    return false;
  }
};

export const getUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const logout = () => {
  sessionStorage.removeItem("user");
};
